import Vue from 'vue';

Vue.component('vimeo-inline-background', {
    props: ['json'],

    data() {
        return {
            iframe: null,
        };
    },

    /**
     * Mount this stuff.
     */
    mounted() {
        this.iframe = this.json;

        // Create DOM element from string so we can manipulate it.
        // For more info on Contextual Fragment, check out this
        // awesome guide: https://davidwalsh.name/convert-html-stings-dom-nodes
        const elementFragment = document.createRange().createContextualFragment(this.iframe);
        const element = elementFragment.firstChild;

        // Set dimensions.
        const dimensions = {
            height: element.getAttribute('height'),
            width: element.getAttribute('width'),
        };

        // Set padding on inner wrapper.
        this.$refs.inner.style.paddingBottom = `${(dimensions.height / dimensions.width) * 100}%`;

        // Check for background parameter, add if missing.
        let { src } = element;
        src += '&background=1&loop=1&color=ffffff&title=0&byline=0&portrait=0';
        console.log(src);
        element.setAttribute('src', src);
        // element.src = '';
        // element.classList.add('lazyload');
        element.setAttribute('allowFullScreen', true);
        element.setAttribute('webkitallowfullscreen', true);
        element.setAttribute('mozallowfullscreen', true);

        // Append the iframe element.
        this.$refs.inner.appendChild(element);
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {

    },
});
